import { ErrorView } from "@/components/_molecules/error-view";
import { Loading } from "@/components/_molecules/loading-view";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { DataRequestDatatable } from "../components/data-request-datatable/data-request-datatable";
import { useGetDataRequestListQuery } from "../hooks/api/use-get-data-request-list";

export const DataRequestListPage = () => {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { dataRequestList, loading, error } = useGetDataRequestListQuery({
    workspaceId: currentWorkspace.id,
  });

  if (loading) return <Loading />;
  if (error) return <ErrorView />;

  return (
    <div className="flex h-full max-h-full flex-col overflow-y-hidden">
      <DataRequestDatatable dataRequestList={dataRequestList} workspace={currentWorkspace} />
    </div>
  );
};
